<template>
  <div class="">
    <NavTop class="navbar">
    </Navtop>
    <div class="center">
      <div class="department-page ">
        <div class="item">
          <div class="title">{{ teacher.name }}</div>
          <ul class="department-list">
            <li style="cursor: pointer;" v-for="(item, index) in teacher.children" :key="index">
              <div class="row" @click="navigateTo(item)">
                <span class="text">{{ item.name }}</span>
                <div class="right_img">
                  <img src="@/assets/images/pink_right.png" alt>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="item">
          <div class="title">{{ zhiNeng.name }}</div>
          <ul class="department-list">
            <li style="cursor: pointer;"
                v-for="(item, index) in zhiNeng.children" :key="index">
              <div class="row" @click="navigateTo(item)">
                <span class="text">{{ item.name }}</span>
                <div class="right_img">
                  <img src="../../assets/images/pink_right.png">
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import NavTop from '../../components/comcomponents/NavTop.vue'
import home from '../../api/home.js'
import child from '../../api/child'

export default {
  name: 'DepartmentPage',
  components: {NavTop},
  data () {
    return {
      // 教学部门
      teacher: {},
      // 职能部门
      zhiNeng: {}
    }
  },
  created () {

  },
  mounted () {
    this.getNav() // 导航
  },
  methods: {
    // 获取导航栏
    async getNav () {
      try {
        const res = await home.getNav({id: 1})
        if (res.code == 200) {
          // 子模块总和
          let childMenu = res.data.children.filter(item => item.id == 3)[0].children
          this.teacher = childMenu[0]
          this.zhiNeng = childMenu[1]
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 点击跳转
    navigateTo (item) {
      console.log(1111,item)
      // 检查字符串是否以https开头
      if (item.path.startsWith('https')) {
        window.open(item.path, '_blank')
        return
      }
      if (item.appointTabId) {
        this.$router.push(item.path + item.appointTabId)
        return
      }
      if (!item.tabBarId) {
        this.$router.push(item.path + '/' + item.id)
        return
      }
      if (item.tabBarId) {
        this.$router.push(item.path + '/' + item.tabBarId)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.el-dropdown-link {
  color: #FFFFFF;
}


//.row {
//  display: flex;
//  justify-content: space-between;
//  flex-direction: row;
//  align-items: center;
//  height: auto;
//}
.row {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 100%;
}

.text {
  flex: 1;
  white-space: normal; // 允许换行
  word-break: break-all; // 长英文/连续字符强制换行
  line-height: 1.4; // 多行文字行间距
  min-width: 0;                // 关键：允许文本在 flex 容器内收缩换行
}
.right_img {
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 20px;
  flex-shrink: 0; // 箭头不压缩
  img {
    width: 100%;
    height: 100%;

  }
}

//修改
.item {
  margin-bottom: 110px;
}

.department-page {

  font-family: Arial, sans-serif;
  margin: 60px 20px;
}

.title {
  margin-bottom: 30px;
  font-size: 28px;
  font-weight: bolder;
  color: #333;
  border-bottom: none;
}

.department-list {
  list-style: none;
  padding-left: 0;
  display: flex;
  flex-wrap: wrap;

}

.department-list li {
  display: inline-block;
  border: 1px solid #ce8386;
  border-left: 6px solid #9e070e;
  width: calc((100% / 4) - 2%);
  margin: 1% 1% 1% 0;
  height: 55px;
  padding-left: 20px;
  min-height: 55px; // 最小高度，文字变多自动撑开
  background: url('/') no-repeat left center;
  background-size: 12px;
  color: #333;
}

.department-list li:hover {
  color: #9e070e;
}

.department-page h3 + .department-list {
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Institution/index.vue